/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { ContinuousRubricRow } from './ContinuousRubricRow';
import { DiscreteRubricRow } from './DiscreteRubricRow';
import { Enabled } from './Enabled';
import { Fraction } from './Fraction';
const EnabledRubricParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'fixedMaxPoints',
        /* #__PURE__ */ parsers.maybeNull(Fraction),
        'fixed_max_points',
    ],
    [
        'rows',
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['continuous', ContinuousRubricRow],
            ['discrete', DiscreteRubricRow],
        ])),
    ],
]), Enabled);
export class EnabledRubric extends Enabled {
    static decode(input) {
        return EnabledRubricParser.decode(input).map(res => new EnabledRubric(res));
    }
    static unsafeDecode(input) {
        return EnabledRubric.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return EnabledRubricParser.encode(data);
    }
    static schema() {
        return EnabledRubricParser.schema();
    }
}
